const initialState = {
    cats: [],
    
};
const categories = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_CATEGORIES':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default categories;
